import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/root/elawphant/src/widgets/footer/ui/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/root/elawphant/src/widgets/header/ui/Header.tsx");
